<template>
  <svg :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <!-- Versão 1: Mais detalhada -->
    <g v-if="variant === 'detailed'">
      <!-- Corpo do cadeado -->
      <rect x="6" y="10" width="12" height="10" rx="2" ry="2" stroke-width="2" />
      <!-- Arco do cadeado -->
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10V6a4 4 0 118 0v4" />
      <!-- Ponto da fechadura -->
      <circle cx="12" cy="15" r="1.5" fill="currentColor" />
    </g>

    <!-- Versão 2: Mais simples -->
    <g v-else-if="variant === 'simple'">
      <!-- Corpo do cadeado -->
      <rect x="7" y="11" width="10" height="8" rx="1" ry="1" stroke-width="2" />
      <!-- Arco do cadeado -->
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 11V7a3 3 0 116 0v4" />
    </g>

    <!-- Versão 3: Minimalista (padrão) -->
    <g v-else>
      <!-- Corpo do cadeado com cantos arredondados -->
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5a2 2 0 00-2 2v6a2 2 0 002 2h14a2 2 0 002-2v-6a2 2 0 00-2-2z" />
      <!-- Arco do cadeado -->
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11V7a5 5 0 0110 0v4" />
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  class?: string
  variant?: 'detailed' | 'simple' | 'minimal'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  class: 'text-body',
  variant: 'detailed',
})

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-4 w-4 lg:h-5 lg:w-5',
  lg: 'h-6 w-6',
}

const iconClass = computed(() => `${sizeClasses[props.size]} ${props.class}`)
</script>
